/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Review_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Review request sent" |
*
* @param {Iconik_Publish_Review_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_review_success_toast = /** @type {((inputs?: Iconik_Publish_Review_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Review_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "it") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "es") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Review request sent")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Review request sent")
	return /** @type {LocalizedString} */ ("Review request sent")
});